export const iconFontAwesomeMediaplaybackArrowRotateLeft = (
	<i className="fa-solid fa-arrow-rotate-left"></i>
);
